import { Component, Inject, OnInit } from '@angular/core';
import { CommonsSessionStorageService, downgradeToAJSComponent, CommonsBrowserStorageService } from 'ib-web-commons/utils';
import { IbMmbPaymentsPageService } from './services/ib-Mmb-payments-page.service';
import { PaymentViewType } from './enums/ib-Mmb-payments-enum';
import { AJSMmbModalService, MmbModalServiceType } from '@src/components/ib-reusable-components/ib-MmB-modal/services/upgraded/ib-Mmb-modal-service-bridge.service';
import { MmBAppConstants } from '@src/ib-MmB-constants';
@Component({
    selector: 'ib-mmb-payment-page',
    templateUrl: 'ib-Mmb-payment-page.component.html',
    providers: [
        IbMmbPaymentsPageService
    ]
})
export class IbMmbPaymentPageComponent implements OnInit {
    //Asign EMPTY to no render any component
    public readonly PaymentViewType = PaymentViewType;
    public componentType: string = PaymentViewType.EMPTY;
    constructor (
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private CommonsBrowserStorageService: CommonsBrowserStorageService,
        private IbMmbPaymentsPageService : IbMmbPaymentsPageService,
        @Inject(AJSMmbModalService) private MmbModalService: MmbModalServiceType
    ){}


    async ngOnInit () {
        this.CommonsSessionStorageService.set('actualStepFlow', 'ohinfo');
        const forcePaymentType =  this.CommonsBrowserStorageService.get<string>('ib-MmB-app.forcePaymentType' );

         // TEST: HIDE TO PRO
        if (forcePaymentType === 'CHECK') {
            this.componentType = await this.IbMmbPaymentsPageService.checkPaymentsViewType();
        } else if (forcePaymentType === 'NEW') {
            this.componentType = PaymentViewType.NEW;
        } else {
            this.componentType = PaymentViewType.OLD;
        }

        //  // HIDE TO PREE
        // this.componentType = await this.IbMmbPaymentsPageService.checkPaymentsViewType();
    }

    forceOld = (): void => {
        this.CommonsSessionStorageService.set(MmBAppConstants.STORAGE_KEYS.PAYMENTS_VIEWTYPE, this.PaymentViewType.OLD);
        this.componentType = PaymentViewType.OLD;
    }

}
downgradeToAJSComponent(
    'ibMmbPaymentPage',
    {
        component: IbMmbPaymentPageComponent,
        inputs: [],
        outputs: []
    },
    'ib-mmb-payment-page-module',
    []
);
